import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Wrap = styled.div`
  max-width: 760px;
  margin: 60px auto;
  padding: 24px;
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.94);
  border-radius: 18px;
  padding: 28px;
  color: #111;
`;

const Title = styled.h1`
  margin: 0 0 14px;
  font-size: clamp(26px, 5vw, 42px);
`;

const Text = styled.p`
  line-height: 1.6;
  margin: 0 0 20px;
`;

const Button = styled(Link)`
  display: inline-block;
  padding: 12px 20px;
  border-radius: 10px;
  background: #111;
  color: #fff;
  text-decoration: none;
  font-weight: 700;
`;

export default function PayPalResult({ cancelled = false }) {
  return (
    <Wrap>
      <Card>
        <Title>
          {cancelled ? 'Payment cancelled' : 'Payment confirmation'}
        </Title>

        <Text>
          {cancelled
            ? 'The PayPal payment was cancelled. No payment confirmation has been recorded.'
            : 'PayPal is confirming your payment. Your order will be marked as paid only after Moloman receives the verified PayPal confirmation.'}
        </Text>

        <Button to="/me">
          Go to My Account
        </Button>
      </Card>
    </Wrap>
  );
}
